import {useCallback, useMemo, useState} from 'react';
import {LocationApplication} from '@application/Site';
import {ConfigurationApplication} from '@application/Config';
import {MaintenanceConfig} from '@modules/maintenance/core/domain/MaintenanceModeRepository';
import {ApiMaintenanceModeRepository} from '@modules/maintenance/core/infrastructure/repositories/ApiMaintenanceModeRepository';

export interface UseMaintenanceResult {
  isInMaintenance: boolean;
  checkMaintenanceStatus: () => Promise<void>;
}

const tradename = ConfigurationApplication.retrieve().tradename;

export const useMaintenance = (): UseMaintenanceResult => {
  const [maintenanceConfig, setMaintenanceConfig] = useState<MaintenanceConfig>();

  const country = useMemo(() => LocationApplication.getLocale().country, []);

  const checkMaintenanceStatus = useCallback(async () => {
    const cfg = await ApiMaintenanceModeRepository.getMaintenanceConfig();
    setMaintenanceConfig(cfg);
  }, []);

  const isInMaintenance = useMemo(() => {
    if (!maintenanceConfig) return false;

    const isTradenamesArrayEmpty = maintenanceConfig.tradenames.length === 0;
    const isTradenameInMaintenanceMode = maintenanceConfig.tradenames.includes(tradename);

    const isCountriesArrayEmpty = maintenanceConfig.countries.length === 0;
    const isCountryInMaintenanceMode = maintenanceConfig.countries.includes(country);

    return (
      maintenanceConfig.enabled &&
      (isTradenameInMaintenanceMode || isTradenamesArrayEmpty) &&
      (isCountryInMaintenanceMode || isCountriesArrayEmpty)
    );
  }, [maintenanceConfig, country]);

  return {isInMaintenance, checkMaintenanceStatus};
};
